"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

require("./SzModal.scss");

function SzModal(props) {
  var handleClose = props.handleClose,
      show = props.show,
      title = props.title,
      children = props.children,
      className = props.className,
      size = props.size;
  var modalClasses = classnames_1.default('sz-modal text-primary', className);
  return react_1.default.createElement(react_bootstrap_1.Modal, {
    className: modalClasses,
    show: show,
    onHide: handleClose,
    size: size
  }, react_1.default.createElement(react_bootstrap_1.Modal.Header, {
    className: "sz-modal__header border-0 p-0 text-uppercase font-family-bold",
    closeButton: true
  }, react_1.default.createElement(react_bootstrap_1.Modal.Title, {
    className: "sz-modal__title sz-underline sz-normal-font-size"
  }, title)), react_1.default.createElement(react_bootstrap_1.Modal.Body, {
    className: "p-0"
  }, children));
}

exports.default = SzModal;
SzModal.defaultProps = {
  size: 'lg'
};
SzModal.propTypes = {
  handleClose: prop_types_1.default.func,
  show: prop_types_1.default.bool,
  title: prop_types_1.default.string,
  children: prop_types_1.default.node,
  className: prop_types_1.default.string,
  size: prop_types_1.default.oneOf(['sm', 'lg', 'xl'])
};